import React, { useContext, useState } from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { AuthContext } from "../contexts/auth";
import { GlobalContext } from "../contexts/global";
import Validade from "../helpers/validate";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import Button from "./Button";
import CaixaTextoInputIcone from "./TextBoxIcon";
import { SendPaymentReceipt } from "../services/Api/historic";
import { IS_WEB } from "../services/Config";

export default function ReceiptEmail({
  modalVisible,
  setModalVisible,
  receiptId,
}) {
  const [email, setEmail] = useState(null);
  const [validEmail, setValidEmail] = useState({
    isValid: true,
    invalidMessage: "Digite um email válido",
  });
  const { emailUser } = useContext(AuthContext);
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);

  const sendValidEmail = (email) => {
    if (!Validade.Email(email ?? "")) {
      setValidEmail({
        isValid: false,
        invalidMessage: "Digite um email válido",
      });
    } else {
      setLoading({ show: true, message: "Enviando recibo por email." });
      sendPaymentReceiptToEmail(receiptId, email);
    }
  };

  const sendPaymentReceiptToEmail = (idHistoricReceipt, emailReceipt) => {
    SendPaymentReceipt(idHistoricReceipt, emailReceipt)
      .then((value) => {
        setModalVisible(!modalVisible)
        setShowAlert({
          type: "success",
          title: "Sucesso",
          message: "Email enviado com sucesso.",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
            // return navigation.goBack()
          },
        });
      })
      .catch((value) => {
        setShowAlert({
          type: "alert",
          title: "Erro ao tentar enviar o email",
          message: (value.erro ?? value.message) ?? "Não informado",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "Enviando recibo por email." });
        setEmail("");
      });
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      style={{ backgroundColor: "#000" }}
      visible={modalVisible}
      onRequestClose={() => setModalVisible(!modalVisible)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Icon
            name="close"
            size={32}
            onPress={() => {
              setModalVisible(!modalVisible);
            }}
            style={styles.closeButton}
          />
          <View style={styles.titleView}>
            <Text style={styles.titleText}>{"Recebimento"}</Text>
          </View>
          <View style={styles.subTitleView}>
            <Text style={styles.subTitleText}>{"Digite um email"}</Text>
            <CaixaTextoInputIcone
              iconName={"email-outline"}
              placeholderInput={"Email"}
              keyboardType={"email-address"}
              onChangeTextInput={(email) => setEmail(email)}
              value={email}
              textContentType={"emailAddress"}
              styleBox={{ width: 250, marginTop: 16 }}
              {...validEmail}
            />
          </View>
          <View style={styles.viewButton}>
            {!IS_WEB ? (
              <Button
                textoBotao={"Padrão"}
                estilo={{ backgroundColor: Colors.INFO }}
                onPress={() => (emailUser ? setEmail(emailUser) : null)}
              />
            ) : null}
            <Button
              textoBotao={"Confirmar"}
              estilo={{ backgroundColor: Colors.SUCCESS, marginLeft: 16 }}
              onPress={() => sendValidEmail(email)}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  titleView: {
    marginBottom: 8,
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
  },
  subTitleView: {
    alignItems: "center",
  },
  subTitleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.GRAY_DARK,
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  closeButton: {
    marginLeft: "auto",
    color: Colors.GRAY_DARK,
  },
  viewButton: {
    marginTop: 16,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  amountText: {
    fontSize: Fonts.FONT_SIZE_24,
    color: Colors.BLACK,
    fontWeight: "500",
  },
});
